import { Link as LinkR } from 'react-router-dom';
import styled from 'styled-components';
import _default from '../../themes/default';



export const Nav = styled.div`
    background-color: ${({theme}) => theme.card_light};
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1rem;
    position: sticky;
    top: 0;
    z-index: 10;
    @media (max-width: 960px) {
        trastion: 0.8s all ease;
    }
`;
export const NavbarContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 60px;
  z-index: 1;
  width: 100%;
  padding: 0 24px;
  max-width: 1200px;
`;
export const NavLogo = styled(LinkR)`
    width: 80%;    
    padding: 0 6px;
    display: flex;
    justify-content: start;
    align-items: center;
    text-decoration: none;
    

    @media (max-width: 640px) {
        padding: 0 0px;
    }

    img {
        width: 40px; 
        height: auto;
        margin-right: 10px; 
    }

    .icon {
        font-size: 24px; 
        margin-left: 10px; 
    }
`;
export const Span = styled.div`
    padding: 0 4px;
    font-weight: bold;
    font-size: 18px;
`;
export const NavItems = styled.ul`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content:center;
    gap: 32px;
    padding: 0 6px;
    list-style: none;

    @media screen and (max-width: 768px) {
      display: none;
    }
`;
export const GithubLogo = styled.a`
  svg {
    fill: ${({ theme }) => theme.text_primary}; /* Initial color */
    transition: fill 0.2s ease-in-out, transform 0.4s cubic-bezier(0.165, 0.84, 0.44, 1) 0.1s; /* Transition fill color and transform */
    height: 25px; /* Set the SVG height */
    width: 25px; /* Set the SVG width */
    margin-right: 15px; /* Add margin to the right */
    transform-origin: center; /* Center the transform origin for scaling */
  }

  &:hover {
    svg {
      fill: ${({ theme }) => theme.primary}; /* Color change on hover */
      transform: scale(1.1); /* Scale transformation on hover */
    }
  }
`;
export const LinkdinLogo = styled.a`
  svg {
    fill: ${({ theme }) => theme.text_primary}; /* Initial color */
    transition: fill 0.2s ease-in-out, transform 0.4s cubic-bezier(0.165, 0.84, 0.44, 1) 0.1s; /* Transition fill color and transform */
    height: 25px; /* Set the SVG height */
    width: 25px; /* Set the SVG width */
    margin-right: 15px; /* Add margin to the right */
    transform-origin: center; /* Center the transform origin for scaling */
  }

  &:hover {
    svg {
      fill: ${({ theme }) => theme.primary}; /* Color change on hover */
      transform: scale(1.1); /* Scale transformation on hover */
    }
  }
`;
export const EmailLogo = styled.a`
  svg {
    fill: ${({ theme }) => theme.text_primary}; /* Initial color */
    transition: fill 0.2s ease-in-out, transform 0.4s cubic-bezier(0.165, 0.84, 0.44, 1) 0.1s; /* Transition fill color and transform */
    height: 25px; /* Set the SVG height */
    width: 25px; /* Set the SVG width */
    margin-right: 15px; /* Add margin to the right */
    transform-origin: center; /* Center the transform origin for scaling */
  }

  &:hover {
    svg {
      fill: ${({ theme }) => theme.primary}; /* Color change on hover */
      transform: scale(1.1); /* Scale transformation on hover */
    }
  }
`;
export const NavLink = styled.a`
    color: ${({ theme }) => theme.text_primary};
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease-in-out;
    text-decoration: none;
     transform-origin: center;
    :hover {
      color: ${({ theme }) => theme.primary};
       transform: scale(1.1);

    }

    &.active {
      border-bottom: 2px solid ${({ theme }) => theme.primary};
    }
`;
export const ButtonContainer = styled.div`
  width: 80%;  
  height: 100%;
  display: flex;
  justify-content: end;
  align-items: center;
  padding: 0 6px;
  @media screen and (max-width: 768px) {
    display: none;
  }
`;


export const MobileIcon = styled.div`
  display: none;
  @media screen and (max-width: 768px) {
    display: block;
    position: absolute;
    top: 0;
    right: 0;
    transform: translate(-100%, 60%);
    font-size: 1.5rem;
    cursor: pointer;
    color: ${({ theme }) => theme.text_primary};
  }
`
export const MobileIconsContainer = styled.div`
    @media screen and (max-width: 768px) {
        display: flex;
        flex-direction: row;
        justify-content: flex-start; 
        align-items: center; 
        width: 100%;
        gap: 1px;
    }
`;

export const MobileMenu = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 16px;
    position: absolute;
    top: 80px;
    right: 0;
    width: 100%;
    padding: 12px 40px 24px 40px;
    background: ${({ theme }) => theme.card_light+99};
    transition: all 0.6s ease-in-out;
    transform: ${({ isOpen }) => (isOpen ? 'translateY(0)' : 'translateY(-100%)')};
    border-radius: 0 0 20px 20px;
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.2);
    opacity: ${({ isOpen }) => (isOpen ? '100%' : '0')};
    z-index: ${({ isOpen }) => (isOpen ? '1000' : '-1000')};

`

export const MobileMenuItems = styled.ul`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 32px;
  list-style: none;
  width: 100%;
  height: 100%;
`

export const MobileMenuLink = styled(LinkR)`
  color: ${({ theme }) => theme.text_primary};
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  text-decoration: none;
  :hover {
    color: ${({ theme }) => theme.primary};
  }

  &.active {
    border-bottom: 2px solid ${({ theme }) => theme.primary};
  }
`;

export const MobileMenuButton = styled.a`
  border: 1.8px solid ${({ theme }) => theme.primary};
  justify-content: center;
  display: flex;
  align-items: center;
  height: 70%;
  border-radius: 20px;
  color: ${({ theme }) => theme.primary};
  cursor: pointer;
  padding: 0 20px;
  font-weight: 500;
  text-decoration: none;
  font-size: 16px;
  transition: all 0.6s ease-in-out;

  :hover {
    background: ${({ theme }) => theme.primary};
    color: ${({ theme }) => theme.white};
  }
`;

export  const MobileLink = styled.a`
  color: ${({ theme }) => theme.text_primary};
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  text-decoration: none;
  :hover {
    color: ${({ theme }) => theme.primary};
  }

  &.active {
    border-bottom: 2px solid ${({ theme }) => theme.primary};
  }
`;

export const MobileNavLogo = styled(LinkR)`
  width: 80%;
  padding: 0 6px;
  display: flex;
  justify-content: start;
  align-items: center;
  text-decoration: none;
  @media (max-width: 640px) {
    padding: 0 0px;
  }
`;